import { useMemo } from 'react';
import { CmsOffer } from '../../../../../../types/cmsProduct';
import { useCmsClientContext } from '../../../../../../utils/cmsPageContext';
import { LoanSearchParams } from '../../../../../../utils/searchParams/loanSearchParams';
import { formatOfferReward } from '../../formatOfferReward';
import { getOfferReward } from '../../getOfferReward';
import { ProductDetailsSectionOffersPlAsideModalEntry } from './ProductDetailsSectionOffersPlAsideModal';
import { getGiftSets } from './utils/getGiftSets';

type UseProductDetailsSectionOffersPlAsideModalParams = {
  offers: CmsOffer[];
  loanSearchParams?: LoanSearchParams;
};

// Builds the details panel entries — one per offer, in the section's order —
// for the page's loan selection (CMS-2023 mapping rows 22–28).
export const useProductDetailsSectionOffersPlAsideModal = ({
  offers,
  loanSearchParams,
}: UseProductDetailsSectionOffersPlAsideModalParams): ProductDetailsSectionOffersPlAsideModalEntry[] => {
  const { currencyDisplay } = useCmsClientContext();
  const amount = Number(loanSearchParams?.amount);
  const tenure = Number(loanSearchParams?.tenure);

  return useMemo(
    () =>
      offers.map((offer, index) => ({
        key: `${index}-${offer.uid ?? offer.title}`,
        title: offer.offer_title,
        type: offer.type,
        reward: formatOfferReward(
          getOfferReward(offer, amount, tenure),
          currencyDisplay,
        ),
        introduction: offer.introduction || undefined,
        description: offer.description || undefined,
        giftSets: getGiftSets(offer, amount, tenure, currencyDisplay),
      })),
    [offers, amount, tenure, currencyDisplay],
  );
};
